import api from 'src/config/api';
import {
	ICreateJobRequestData,
	IGetJobsRequestParams,
	IJob,
} from 'src/features/job/domain/types';

export const jobsApi = {
	createJob: async (
		createJobFormData: ICreateJobRequestData,
		siteSlug: string,
	): Promise<IJob> => {
		const response = await api.post('/api/v1/job', createJobFormData, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},

	getJobs: async (
		requestParams: IGetJobsRequestParams,
		siteSlug: string,
	): Promise<IPaginatedResponse<IJob>> => {
		const { page = 1, sort, order } = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
			...(sort && order && { sort, order }),
		});

		const response = await api.get(`/api/v1/jobs?${params}`, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},

	getJob: async (jobId: number, siteSlug: string): Promise<IJob> => {
		const response = await api.get(`/api/v1/job/${jobId}`, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},

	deleteJob: async (jobId: number, siteSlug: string): Promise<void> => {
		await api.delete(`/api/v1/job/${jobId}`, {
			headers: {
				Site: siteSlug,
			},
		});
		return;
	},
};
